import { ApiError } from '@gorila-shared-ui/components';
import { ShareLinkDuration } from '../types/app';
import { postRequest } from './api';
import { shareLinkUrl } from './urls/publicUrl';

export const createShareLink = async ({
  clientId,
  subClientId,
  hours,
  assetId,
  email,
  groupId,
}: {
  clientId: string;
  subClientId: string;
  hours: ShareLinkDuration;
  assetId?: string;
  groupId?: string;
  email?: string;
}): Promise<{ link?: string; error?: ApiError }> => {
  const response = await postRequest(shareLinkUrl, {
    body: { clientId, subClientId, groupId, assetId, email, hours },
  });

  return {
    link: response?.data?.link,
    error: response?.error,
  };
};
